export default function LoadingSpinner({ size = 'lg', message }) {
  const sizeClasses = size === 'sm'
    ? 'h-5 w-5 border-2'
    : 'h-10 w-10 border-3';

  const spinner = (
    <div className={`${sizeClasses} animate-spin rounded-full border-gray-600 border-t-indigo-500`} />
  );

  if (size === 'sm') return spinner;

  return (
    <div className="flex flex-col items-center justify-center min-h-[40vh] gap-4">
      {spinner}
      {message && <p className="text-gray-400 text-sm">{message}</p>}
    </div>
  );
}
